import "./index.0.css";
const __script_base__ = {
  name: 'WSpacer',
  props: {},
  computed: {
    spacerStyle() {
      return {};
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "w-spacer",
    style: _vm.spacerStyle
  });
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Spacer/index.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);